import { render, staticRenderFns } from "./ssr-manage-add.vue?vue&type=template&id=3f554853&scoped=true"
import script from "./ssr-manage-add.vue?vue&type=script&lang=js"
export * from "./ssr-manage-add.vue?vue&type=script&lang=js"
import style0 from "./ssr-manage-add.vue?vue&type=style&index=0&id=3f554853&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f554853",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f554853')) {
      api.createRecord('3f554853', component.options)
    } else {
      api.reload('3f554853', component.options)
    }
    module.hot.accept("./ssr-manage-add.vue?vue&type=template&id=3f554853&scoped=true", function () {
      api.rerender('3f554853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/ssr-manage-add.vue"
export default component.exports